export * from './catalog.component';
export * from './catalog.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/catalog/index.ts